import React, { useEffect, useState } from 'react'
import {
  Button,
  Form,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalHeader,
  Spinner
} from 'reactstrap'
import { toast } from 'react-toastify'

interface IProps {
  isOpen: boolean
  setOpenPopup: (arg: boolean) => void
  boothId: string | undefined
  boothName: string | undefined
  currentNotes: string
  canEdit: boolean
  handleUpdateBoothNotes: (id: string, notes: string) => Promise<string>
}

const BoothNotesModal: React.FC<IProps> = ({
  isOpen,
  setOpenPopup,
  boothId,
  boothName,
  currentNotes,
  canEdit,
  handleUpdateBoothNotes
}) => {
  const [notes, setNotes] = useState<string>(currentNotes || '')
  const [saving, setSaving] = useState<boolean>(false)

  // Modal her açıldığında / farklı booth seçildiğinde mevcut notları yükle
  useEffect(() => {
    if (isOpen) {
      setNotes(currentNotes || '')
    }
  }, [isOpen, currentNotes, boothId])

  const togglePopup = () => {
    setOpenPopup(!isOpen)
  }

  const handleSave = async () => {
    if (!boothId) return
    setSaving(true)
    try {
      const message = await handleUpdateBoothNotes(boothId, notes)
      if (message === 'SUCCESSFULL') {
        toast.success('Booth notu kaydedildi')
        setOpenPopup(false)
      } else {
        toast.error(typeof message === 'string' ? message : 'Not kaydedilemedi')
      }
    } catch (e) {
      toast.error('Not kaydedilirken bir hata oluştu')
    } finally {
      setSaving(false)
    }
  }

  return (
    <Modal isOpen={isOpen} toggle={togglePopup} scrollable={true} id='boothNotesModal'>
      <ModalHeader className='modal-title' toggle={togglePopup}>
        {boothName ? `Booth Notları — ${boothName}` : 'Booth Notları'}
      </ModalHeader>
      <ModalBody>
        <Form
          onSubmit={(e) => {
            e.preventDefault()
            if (canEdit) handleSave()
          }}
        >
          <FormGroup>
            <Label htmlFor='booth-notes' className='form-label mb-1 fw-semibold'>
              Bu booth'a ait notlar / bilgiler
            </Label>
            <Input
              type='textarea'
              id='booth-notes'
              name='notes'
              rows={8}
              placeholder='Bu booth ile ilgili bilgileri buraya yazın (lokasyon, donanım, iletişim, bakım notları vb.)'
              value={notes}
              onChange={(e) => setNotes(e.target.value)}
              disabled={!canEdit || saving}
              style={{ resize: 'vertical' }}
            />
          </FormGroup>
          <div className='modal-footer px-0 pb-0'>
            <Button color='light' type='button' onClick={() => setOpenPopup(false)}>
              Kapat
            </Button>
            {canEdit && (
              <Button color='primary' type='submit' disabled={saving}>
                <div className='flex align-items-center'>
                  {saving ? <Spinner size='sm'> Loading... </Spinner> : 'Kaydet'}
                </div>
              </Button>
            )}
          </div>
        </Form>
      </ModalBody>
    </Modal>
  )
}

export default BoothNotesModal
